/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
// TODO fix and remove eslint disables
import { db } from '../Firebase';
import { collection as fbCollection, query, orderBy, doc, CollectionReference, updateDoc, } from 'firebase/firestore';
import { collectionData } from 'rxfire/firestore';
import { of, tap, withLatestFrom } from 'rxjs';
import { PlayerArrayT, PartialPlayerT } from '../shared/codecs/Player';
import { switchMap, map, catchError, shareReplay, startWith, combineLatest } from 'rxjs';
import { authed_user } from '../Users/observables';
import { decodeWithOrError } from '../rxjs/Decode';
import { DateTime } from 'luxon';
import * as api from '../utilities/backendApi';
import { state, set_state } from '../Game/State';
import { attemptToAddPlayer } from './utilities';
export const players_collection = authed_user.pipe(map((user) => fbCollection(db, 'organizations', user.organization, 'players')), tap(playersCollection => {
    console.log('New Players Collection: ');
    console.log(playersCollection);
}), shareReplay(1));
export const players = authed_user.pipe(switchMap(user => {
    const players_collection = fbCollection(db, 'organizations', user.organization, 'players');
    return collectionData(query(players_collection, orderBy('name'))).pipe(decodeWithOrError(PlayerArrayT), catchError(err => {
        if (err instanceof Error) {
            console.error('Error thrown while decoding the players');
        }
        return of([]);
    }), map((players) => players.filter(player => player.lastSeen > DateTime.now().minus({ hours: 1 }))), tap(players => console.log(`Players: ${players.length}`)), shareReplay(1));
}), startWith([]), shareReplay(1));
export const in_retro = players.pipe(withLatestFrom(authed_user), map(([players, authed_user]) => !!players.find(player => player.uid === authed_user.uid)), shareReplay(1));
export const add_self_to_lobby = authed_user.pipe(map((user) => {
    return () => {
        return attemptToAddPlayer(user.organization);
    };
}), shareReplay(1));
export const remove_self = authed_user.pipe(map(user => {
    return () => api.removePlayer({ org_uid: user.organization, player_uid: user.uid });
}), shareReplay(1));
export const update_last_seen = authed_user.pipe(map(user => {
    return () => updateDoc(doc(db, 'organizations', user.organization, 'players', user.uid), PartialPlayerT.encode({
        lastSeen: DateTime.now(),
    }));
}), shareReplay(1));
export const remove_player = combineLatest([
    authed_user,
    state,
]).pipe(map(([user, state]) => {
    return (uid) => {
        if (uid === user.uid) {
            throw new Error('You cannot remove yourself!');
        }
        if (uid === state.leader) {
            throw new Error('You cannot remove the leader, assign another leader first.');
        }
        return api.removePlayer({ org_uid: user.organization, player_uid: uid });
    };
}), shareReplay(1));
export const assign_leader = combineLatest([
    authed_user,
    set_state,
]).pipe(map(([_, set_state]) => {
    return (uid) => {
        return set_state({ leader: uid });
    };
}), shareReplay(1));
